import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleMapsProvider } from './providers/GoogleMapsProvider';
import { AuthProvider } from './contexts/AuthContext';
import { MainLayout } from './components/Layout/MainLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './pages/Login';
// Legacy imports removed/commented out to support SSOT migration
// import { SubmarketsPage } from './pages/SubmarketsPage';
// import { SubmarketDetailPage } from './pages/SubmarketDetailPage';
// import { MethodologyPage } from './pages/MethodologyPage';
// import { Properties } from './pages/Properties';
// import { LeadGeneration } from './pages/LeadGeneration';
// import { AIAgent } from './pages/AIAgent';
import { HomePage } from './pages/HomePage';
import { PropertyDetail } from './pages/PropertyDetail';
import { LeadPipelinePage } from './pages/LeadPipelinePage';
import { PlaybookPage } from './pages/PlaybookPage';
import { ZandiMapPage } from './pages/ZandiMapPage';
import { NotFound } from './pages/NotFound';
import { BatchSourcePage } from './pages/BatchSourcePage';
import { ManualDealEntry } from './pages/ManualDealEntry';
import { MarketComparison } from './pages/MarketComparison';
import { BatchResultsPage } from './pages/BatchResultsPage';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GoogleMapsProvider>
          <BrowserRouter>
            <Routes>
              {/* Public route: Login */}
              <Route path="/login" element={<Login />} />

              {/* Protected routes: Require authentication */}
              <Route path="/" element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }>
                {/* Home page */}
                <Route index element={<HomePage />} />

                {/* Legacy Routes - Disabled during SSOT Migration */}
                {/* <Route path="submarkets/:submarketId" element={<SubmarketDetailPage />} /> */}
                {/* <Route path="submarkets" element={<SubmarketsPage />} /> */}
                {/* <Route path="methodology" element={<MethodologyPage />} /> */}
                {/* <Route path="properties" element={<Properties />} /> */}
                {/* <Route path="lead-generation" element={<LeadGeneration />} /> */}
                {/* <Route path="ai-agent" element={<AIAgent />} /> */}

                {/* Active SSOT Routes */}
                <Route path="property/:id" element={<PropertyDetail />} />
                <Route path="leads" element={<LeadPipelinePage />} />
                <Route path="playbook" element={<PlaybookPage />} />
                <Route path="zandi-map" element={<ZandiMapPage />} />
                <Route path="source" element={<BatchSourcePage />} />
                <Route path="batch" element={<BatchResultsPage />} />
                <Route path="batch/:jobId" element={<BatchResultsPage />} />
                <Route path="deal/new" element={<ManualDealEntry />} />

                <Route path="compare" element={<MarketComparison />} />
                {/* <Route path="admin/costs" element={<ApiCostsPage />} /> */}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </GoogleMapsProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
